import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PartnerUsersDashboardRoutingModule } from "./partner-users-dashboard-routing.module";
import { PartnerUsersDashboardComponent } from "./partner-users-dashboard.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FurySharedModule } from "src/@fury/fury-shared.module";
import { MaterialModule } from "src/@fury/shared/material-components.module";
import { NgxPaginationModule } from "ngx-pagination";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTabsModule } from "@angular/material/tabs";
import { SharedModule } from "src/app/shared/shared.module";
import {MatButtonModule} from '@angular/material/button';
import { NgxMaskModule } from "ngx-mask";
import { PartnerLeadsTableComponent } from './partner-leads-table/partner-leads-table.component';
import { CallRailLeadsTableComponent } from './call-rail-leads-table/call-rail-leads-table.component';


@NgModule({
  declarations: [PartnerUsersDashboardComponent, PartnerLeadsTableComponent, CallRailLeadsTableComponent],
  imports: [
    CommonModule,
    PartnerUsersDashboardRoutingModule,
    ReactiveFormsModule,
    FurySharedModule,
    MatTabsModule,
    MatTableModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MaterialModule,
    FormsModule,
    SharedModule,
    MatButtonModule,
    NgxMaskModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PartnerUsersDashboardModule {}
